import React from 'react';
import { Home, Camera, Flame, Shield, Network, Globe, Video, Building2, Bell, Tv, Monitor, Cable, Sun } from 'lucide-react';
import { services } from '../data/mock';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const iconMap = {
  Home,
  Camera,
  Flame,
  Shield,
  Network,
  Globe,
  Video,
  Building2,
  Bell,
  Tv,
  Monitor,
  Cable,
  Sun
};

const ServiceCard = ({ service, index }) => {
  const [cardRef, cardVisible] = useScrollAnimation(0.2);
  const IconComponent = iconMap[service.icon];

  return (
    <div
      ref={cardRef}
      className={`group relative h-full bg-gradient-to-br from-gray-900 to-gray-800/50 border border-gray-700/50 rounded-lg p-6 hover:border-blue-500/30 transition-all duration-300 transform-gpu hover:-translate-y-1 scroll-scale stagger-${index + 1} ${cardVisible ? 'visible' : ''}`}
    >
      {/* Content */}
      <div className="relative z-10">
        {/* Icon / Logo */}
        <div className="mb-4 w-12 h-12 bg-blue-600/10 rounded-lg flex items-center justify-center group-hover:bg-blue-600/20 transition-all duration-300">
          <IconComponent className="w-6 h-6 text-blue-400" />
        </div>

        {/* Title */}
        <h3 className="text-lg font-semibold mb-2 text-white whitespace-pre-line">
          {service.title}
        </h3>

        {/* Description */}
        <p className="text-gray-400 text-sm leading-relaxed">
          {service.description}
        </p>
      </div>
    </div>
  );
};

const Services = () => {
  const [headerRef, headerVisible] = useScrollAnimation(0.2);

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-gray-900 to-black">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div 
          ref={headerRef}
          className={`text-center mb-16 scroll-fade-in ${headerVisible ? 'visible' : ''}`}
        >
          <h2 className="text-4xl md:text-5xl font-semibold mb-4 text-white">Our Services</h2>
          <p className="text-gray-400 text-base max-w-2xl mx-auto">
            Comprehensive smart automation and low voltage infrastructure solutions
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <ServiceCard key={service.id} service={service} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
